// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mode-full .table-bordered td[data-v-343ff500],.mode-full .table-bordered th[data-v-343ff500]{border:3px solid #008ccd!important}.mode-lite .table-bordered td[data-v-343ff500],.mode-lite .table-bordered th[data-v-343ff500]{border:0!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
